function toggleDescribedBy(input, id, shouldInclude) {
  const ids = new Set((input.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
  if (shouldInclude) ids.add(id);
  else ids.delete(id);

  if (ids.size) input.setAttribute('aria-describedby', [...ids].join(' '));
  else input.removeAttribute('aria-describedby');
}

function setFieldError(input, message) {
  const group = input.closest('.fr-input-group');
  if (!group) return;

  const error = group.querySelector('[data-ap-pdf-validation-error]');
  if (message) {
    input.classList.add('fr-input--error');
    input.setAttribute('aria-invalid', 'true');
    group.classList.add('fr-input-group--error');

    if (!error) {
      const errorMessage = document.createElement('p');
      errorMessage.className = 'fr-error-text';
      errorMessage.dataset.apPdfValidationError = 'true';
      errorMessage.id = `${input.id}-validation-error`;
      errorMessage.setAttribute('role', 'alert');
      group.appendChild(errorMessage);
    }

    const validationError = group.querySelector('[data-ap-pdf-validation-error]');
    validationError.textContent = message;
    toggleDescribedBy(input, validationError.id, true);
    return;
  }

  input.classList.remove('fr-input--error');
  input.removeAttribute('aria-invalid');
  group.classList.remove('fr-input-group--error');
  if (error) toggleDescribedBy(input, error.id, false);
  error?.remove();
}

function initializePdfPrescriptionValidation() {
  document.querySelectorAll('form[id^="ap-prescription-form-"], form[id^="pc-prescription-form-"]').forEach((form) => {
    if (form.dataset.requiredValidationInitialized) return;
    form.dataset.requiredValidationInitialized = 'true';

    const fields = [...form.querySelectorAll('[required]')].filter((field) => !field.disabled);
    const message = form.dataset.requiredMessage;
    let hasAttemptedSubmit = false;

    fields.forEach((field) => {
      field.addEventListener('input', () => {
        if (hasAttemptedSubmit) setFieldError(field, field.value.trim() ? null : message);
      });
    });

    form.addEventListener('submit', (event) => {
      hasAttemptedSubmit = true;
      const invalidFields = fields.filter((field) => !field.value.trim());
      fields.forEach((field) => setFieldError(field, field.value.trim() ? null : message));

      if (invalidFields.length) {
        event.preventDefault();
        invalidFields[0].focus();
      }
    });
  });
}

document.addEventListener('turbo:load', initializePdfPrescriptionValidation);
document.addEventListener('DOMContentLoaded', initializePdfPrescriptionValidation);